_getFingerprintProtected